import type { PImage } from '../../engine/aliases'
import { rando } from '../../lib/rando-sidecar'
import { common } from '../../main/common-sidecar'
import { sprites } from '../../sprites/sprites-sidecar'
import { spritesUtil } from '../../sprites/spritesUtil-sidecar'
import { voyageCamera } from './voyageCamera-sidecar'
import { voyageColors } from './voyageColors-sidecar'
import { voyageLayers } from './voyageLayers-sidecar'

export interface IVoyageBackgroundHyper {
  x: number
  y: number
  image: PImage
  depth: number
}

let _speed = 0

export const reset = () => {
  if (_speed > 0) {
    if (objs.length === 0) {
      for (let i = 0; i < 2500; i++) {
        createStar()
      }
    }
    for (let i = 0; i < objs.length; i++) {
      let c = objs[i]
      randomizeStar(c)
    }
    voyageLayers.getLayers().starfield2.sort('depth')
  }
  updateAll()
}

const colors = [voyageColors.yellow, 0xffffff]
const randomizeStar = (obj: IVoyageBackgroundHyper) => {
  let cb = voyageCamera.get().bounds
  let x = rando.f(cb.x, cb.x + cb.w)
  let y = rando.f(cb.y, cb.y + cb.h)

  obj.x = x
  obj.y = y
  obj.image.x = x
  obj.image.y = y

  obj.depth = rando.f(0.1, 1)
  spritesUtil.scale(obj.image, Math.floor(obj.depth * 2))

  obj.image.depth = obj.depth
  obj.image.tint = rando.sample(colors)
  obj.image.alpha = rando.f(0.5, 1)

  obj.image.scaleY = rando.fj(0.5, 0.75)
}

const createStar = () => {
  let image = spritesUtil.createImage(
    rando.sample([voyageLayers.getLayers().starfield2]),
    rando.sample([sprites.voyHyper[0]]),
  )

  let obj: IVoyageBackgroundHyper = {
    image,
    x: 0,
    y: 0,
    depth: 1,
  }
  objs.push(obj)

  return obj
}

const objs: IVoyageBackgroundHyper[] = []

export function updateAll() {
  let ds = common.getUpdateDeltaScaled()

  let cb = voyageCamera.get().bounds

  let maxSpeed = 10000
  let speed = maxSpeed * _speed
  let stretch = 200 * (speed / maxSpeed)

  voyageLayers.getLayers().starfield1.visible = speed <= 0
  voyageLayers.getLayers().starfield2.visible = speed > 0
  if (speed <= 0) {
    return
  }

  for (let i = 0; i < objs.length; i++) {
    let c = objs[i]

    // c.x -= ds * c.depth * 20
    c.x -= ds * c.depth * speed
    if (c.x < cb.x) {
      c.x += cb.w
    }
    if (c.x > cb.x + cb.w) {
      c.x -= cb.w
    }

    c.image.x = c.x //  + -(cx - centerXY.x) * (1 - c.depth * depthScale) * scale
    c.image.y = c.y // + -(cy - centerXY.y) * (1 - c.depth * depthScale) * scale
    c.image.scaleX = stretch * c.depth
    //c.image.scaleY = 0.25
  }
}

export function setSpeed(speed: number) {
  _speed = speed
}
